import { Images } from "@assets/images";

export const ServiceData = [
  {
    img: Images.PC1.default,
    title: "PC RENDER",
    description:
      "PC vật lý chạy trên hệ điều hành Windows. Hỗ trợ VGA 4080 ,4090 …",
  },
  {
    img: Images.PC2.default,
    title: "Dịch vụ Thuê Máy Chủ Vật Lý",
    description:
      "Dịch vụ Thuê Server tại Pc Render Cloud có Phần cứng máy chủ mạnh mẽ, tốc độ mạng nhanh, hiệu năng cao, hỗ trợ 24/7.",
  },
  {
    img: Images.PC3.default,
    title: "PC GIẢ LẬP",
    description:
      "PC vật lý chạy trên hệ điều hành Windows. Hỗ trợ CPU Xeon 2680V4 , 2696V4… cùng VGA 1080 ,1080Ti, 3060 …",
  },
];
